export default __webpack_public_path__ + "static/media/ac_mode_fan_active.54d6970d.svg";